import React, {useEffect, useState} from "react";

const LaborCantidad = ({cantidad, semana, labor, callback,i, j}) => {

    const [valor, setValor] = useState(cantidad);

    useEffect(() => {
    }, [cantidad]);

    const handleChange = (e) => {
        const {value} = e.target;
        callback({ semana, labor, value, i, j });
        setValor(value);
    }

    return (
        <input
            className='form-control form-control-sm'
            style={{backgroundColor:'rgba(236, 246, 255,0.5)'}}
            min={0}
            type="number" onChange={handleChange} value={valor} />
    )
};

export default LaborCantidad;